var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 33,
    viewBox: "0 0 40 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.18791 5L12.5004 1.25L22.8129 5L18.1254 7.8125V10.625C18.1254 10.625 16.8748 9.6875 12.5004 9.6875C8.12604 9.6875 6.87541 10.625 6.87541 10.625V7.8125L2.18791 5ZM2.18791 5V12.5",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1254 9.6875V11.3544C18.1254 14.5756 15.6073 17.1875 12.5004 17.1875C9.39354 17.1875 6.87541 14.5756 6.87541 11.3544V9.6875M26.2217 14.4312C26.2217 14.4312 27.131 13.7694 30.3129 13.7694C33.4948 13.7694 34.4042 14.4294 34.4042 14.4294M26.2217 14.4312V12.5L22.8129 10.625L30.3129 7.8125L37.8129 10.625L34.4042 12.5V14.4294M26.2217 14.4312V14.9712C26.2217 16.0563 26.6527 17.0969 27.42 17.8642C28.1872 18.6315 29.2278 19.0625 30.3129 19.0625C31.398 19.0625 32.4386 18.6315 33.2059 17.8642C33.9731 17.0969 34.4042 16.0563 34.4042 14.9712V14.4294M27.5004 31.25H34.4473C35.8967 31.25 37.0479 30.545 38.0829 29.5587C40.2017 27.5412 36.7235 25.9287 35.3979 25.1394C34.219 24.4435 32.9099 23.9968 31.5516 23.8269C30.1932 23.6569 28.8144 23.7673 27.5004 24.1513M5.72229 23.6112C3.95416 24.5994 -0.682715 26.615 2.14104 29.1369C3.52104 30.3687 5.05666 31.25 6.98978 31.25H18.011C19.9423 31.25 21.4798 30.3687 22.8598 29.1369C25.6835 26.615 21.0467 24.5994 19.2785 23.6112C15.131 21.2956 9.86979 21.2956 5.72229 23.6112Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIes);
export default __webpack_public_path__ + "static/media/IES.7b0589dab638b117a99d9a7c9c20aeb3.svg";
export { ForwardRef as ReactComponent };